import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { Button } from 'sarsaparilla';
import LinkEdit from "../../containers/StewardAssetEditPage/LinkEdit";
import { LinkDefaults, LinkProps } from '../../props/link';

import pageStyles from "../../containers/StewardAssetEditPage/StewardAssetEditPage.scss";

const propTypes = {
  linkType: PropTypes.string,
  value: PropTypes.shape({
    links: PropTypes.arrayOf(LinkProps)
  })
};

const defaultProps = {
  value: []
};

export default class LinkTab extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      links: this.props.value.links
    };

    this.addLink = this.addLink.bind(this);
    this.removeLink = this.removeLink.bind(this);
  }

  addLink() {
    const link = { ...LinkDefaults, _key: uniqueId('link-') };

    this.setState((prevState) => ({ ...prevState, links: [...prevState.links, link] }));
  }

  removeLink(key) {
    this.setState((prevState) => ({
      ...prevState,
      links: prevState.links.filter((link) => link._key !== key)
    }));
  }

  render() {
    const { linkType } = this.props;
    const { links } = this.state;

    return (
      <div className={pageStyles["tab-body"]}>
        {links.map((link) => (
          <LinkEdit
            key={link._key}
            value={link}
            linkType={linkType}
            onRemove={this.removeLink} />
        ))}
        <Button onClick={this.addLink}>
          Add Link
        </Button>
      </div>
    );
  }
}

LinkTab.propTypes = propTypes;
LinkTab.defaultProps = defaultProps;
